import { createContext, useContext } from "react";

type AuditBookingContextValue = {
  hasResult: boolean;
  auditScore: number | null;
  auditHasGaps: boolean;
  openBooking: () => void;
};

const AuditBookingContext = createContext<AuditBookingContextValue>({
  hasResult: false,
  auditScore: null,
  auditHasGaps: false,
  openBooking: () => {},
});

export const AuditBookingProvider = AuditBookingContext.Provider;

export function useAuditBooking() {
  return useContext(AuditBookingContext);
}
